import React, { ChangeEvent, FunctionComponent } from 'react'
import { RadioGroup, Radio, Divider } from '@afterpaytouch/core'
import { Country } from '@afterpay/types'

import { useCountry, useSelectedPreferredDay } from '../../state'
import { useTranslation } from '../../utils/convergence'
import { getLocaleKeyFromDayNumber } from '../../utils/calendar'
import { Weekday } from '../../model'

interface PaymentDayListProps {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

export const PaymentDayList: FunctionComponent<PaymentDayListProps> = ({ onChange }) => {
  const { t } = useTranslation()
  const countryCode = useCountry()
  const selectedPreferredDay = useSelectedPreferredDay()
  const days = countryCode === Country.CA || countryCode === Country.US ? [0, 1, 2, 3, 4, 5, 6] : [1, 2, 3, 4, 5, 6, 0]

  return (
    <RadioGroup name='payment-days' indent defaultValue={`${selectedPreferredDay}`} onChange={onChange}>
      {days.map((day: Weekday, idx) => {
        const key = `payment-day-list-option-${day}`
        return [
          <Radio.Button key={key} label={t(getLocaleKeyFromDayNumber(day))} value={`${day}`} labelWidth='Full' testNameSpace={key} />,
          idx !== days.length - 1 && <Divider margin='No' kind='Hairline' key={`payment-day-list-divider-${day}`} />,
        ]
      })}
    </RadioGroup>
  )
}
